import { birds } from "./birds";
import { getArtist, resolveArtist } from "./artists";
import { Artist, Bird } from "./types";

/**
 * Uma foto = uma mídia de `bird.photos`, já com a ave e o artista resolvidos.
 * Mesmo formato de `Illustration` (data/illustrations.ts).
 */
export interface PhotoItem {
  /** Caminho da imagem. Único; usado como chave. */
  src: string;
  /** Posição dentro de `bird.photos` (usada em /fotos?bird=<id>&img=<index>). */
  index: number;
  /** Nome popular já capitalizado, pronto para exibir. */
  name: string;
  bird: Bird;
  /** Artista canônico (segue `aliasOf`); ausente se a mídia não tem `artistId`. */
  artist?: Artist;
}

// popularName vem em minúsculas no dicionário ("garça-branca-grande")
const capitalize = (s: string): string => s.charAt(0).toUpperCase() + s.slice(1);

// Os dados são estáticos: a lista é montada uma única vez.
// Só entram aves que têm pelo menos uma foto em birds.ts.
export const photos: PhotoItem[] = birds.flatMap((bird) =>
  bird.photos.map((media, index) => ({
    src: media.src,
    index,
    name: capitalize(bird.popularName),
    bird,
    artist: resolveArtist(getArtist(media.artistId)),
  }))
);

/** Fotos de um artista (aceita o id canônico ou um alias). */
export const getPhotosByArtist = (artistId: string): PhotoItem[] => {
  const target = resolveArtist(getArtist(artistId))?.id;
  return target ? photos.filter((p) => p.artist?.id === target) : [];
};
